//COOKIE TRACKING FOR THE UPSELL - BUILT BY TROY
var p31help = {
  cookie: {
    set: function(name, value, days) {
      let expires = "";
      if (days) {
          let date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  	},
    get: function(name) {
      let nameEQ = name + "=";
      let ca = document.cookie.split(';');
      for(let i=0;i < ca.length;i++) {
          let c = ca[i];
          while (c.charAt(0)==' ')
            c = c.substring(1,c.length);
          if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length,c.length);
      }
      return null;
    },
    erase: function(name) {
    	document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
  },
  isMobile: function() {
    return screen.width < 1024;
  },
  doCall: function(args) {
    fetch(args.endpoint, {
      method: args.method,
      ...(args.data != null && {
      	headers: {
        	'Content-Type': 'application/json'
      	},
        body: JSON.stringify(args.data)
      })
    })
    .then(response => response.clone().json())
    .then(obj => {
      if (args.callback != null)
        args.callback(obj);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
};